class SessionStore {
  public static fetch(key: string, maxAge: number = 3600000) {
    const rawData = sessionStorage.getItem(key)

    try {
      if (rawData === undefined) {
        throw new Error("no session")
      }

      const { timestamp, payload } = JSON.parse(rawData)
      const age = Date.now() - timestamp

      if (age > maxAge) {
        throw new Error("expired")
      }

      if (!payload || payload === false) {
        throw new Error("no payload")
      }

      return payload
    } catch (e) {
      return false
    }
  }

  public static save(key: string, payload: Object) {
    const data = { timestamp: Date.now(), payload }
    const rawData = JSON.stringify(data)
    sessionStorage.setItem(key, rawData)
  }
}

export { SessionStore }
